// Simple relevance scoring for articles
export function scoreArticleRelevance(article, searchTerms) {
  let score = 0;
  const text = `${article.title} ${article.content}`.toLowerCase();

  searchTerms.forEach(term => {
    // Title matches are worth more
    if (article.title.toLowerCase().includes(term)) {
      score += 10;
    }
    
    // Content matches
    const contentMatches = (text.match(new RegExp(term, 'g')) || []).length;
    score += contentMatches;
  });

  return score;
} 